'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactGoogleMaps = require('react-google-maps');

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MARKER_WIDTH = 29;
var MARKER_HEIGHT = 42;

var GettingStartedGoogleMap = (0, _reactGoogleMaps.withGoogleMap)(function (props) {
	return _react2.default.createElement(
		'div',
		null,
		_react2.default.createElement(
			_reactGoogleMaps.GoogleMap,
			{
				ref: props.onMapLoad,
				defaultZoom: 12,
				defaultCenter: props.markers && props.markers.length ? props.markers[0].position : { lat: parseFloat('-25.363882'), lng: parseFloat('131.044922') },
				onClick: props.onMapClick
			},
			props.markers && props.markers.map(function (marker, index) {
				return _react2.default.createElement(
					_reactGoogleMaps.Marker,
					{
						key: index,
						position: marker.position,
						icon: {
							url: marker.showInfo ? 'https://vitality.doctify.co.uk/static/img/map-icons/hover.png' : marker.type === 'specialist' && 'https://vitality.doctify.co.uk/static/img/map-icons/specialist.png' || 'https://vitality.doctify.co.uk/static/img/map-icons/practice.png',
							scaledSize: new window.google.maps.Size(MARKER_WIDTH, MARKER_HEIGHT)
						},
						onClick: function onClick() {
							return props.onMarkerClicked(marker);
						}
					},
					marker.showInfo && _react2.default.createElement(
						_reactGoogleMaps.InfoWindow,
						{ onCloseClick: function onCloseClick() {
								return props.onMarkerClosed(marker);
							} },
						_react2.default.createElement(
							'div',
							{
								className: _style2.default.info + ' ' + (marker.type === 'specialist' ? _style2.default.specialist : _style2.default.practice)
							},
							marker.showInfo,
							' ',
							marker.infoContent
						)
					)
				);
			})
		)
	);
});

exports.default = GettingStartedGoogleMap;


// WEBPACK FOOTER //
// ./components/search-page/lib/components/google-maps.js